<div class="recto">
    <span class="diamond"></span>
    <div class="table">
        <div class="table-cell">
            <h6 *ngIf="subtitle != ''" class="section-subtitle" style="margin-bottom: 28px">{{subtitle}}</h6>
            <ng-content></ng-content>
        </div>
    </div>
</div>